import { FrontpageService } from './../../Services/frontpage.service';
import { UploadService } from '../../Services/upload.service';
import { AuthService } from '../../Services/auth.service';
import { EventService } from '../../Services/event.service';
import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import * as $ from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';
// import { TemplateBindingParseResult } from '@angular/compiler';
import { AlertService } from '../../Services/alert.service';
import Swal from 'sweetalert2';
require('bootstrap-colorpicker');


@Component({
  selector: 'app-home-card-edit',
  template: require('./home-card-edit.component.html'),
  styles: [require('./home-card-edit.component.css')]
})

export class HomeCardEditComponent implements OnInit {
  @ViewChild("fileInput") fileInput: ElementRef;
  // @Input('position') position: string;
  
  events: any = [];
  other_items: any = []
  eventType: number = 2;
  meerdaageType: number = 1;
  editor_modules: any = {};
  viewer: boolean = false;
  columnWidthPreview: string = "col-lg-4"
  editItem: any = {};

  videoWidth = "340";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private auth: AuthService,
    private uploadService: UploadService,
    private frontpageService: FrontpageService,
    private alertService: AlertService) {
    
    route.params.subscribe(p => {
        if (p['id']) {
          this.editItem.id = +p['id'];
        }
        else {
          this.editItem.id = -1;
        }
    });
  

    // this.newOtherItem();
    this.editor_modules = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        // ['blockquote', 'code-block'],

        // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        // [{ 'size': ['small', false, 'large', 'huge'] }],
        // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        // [{ 'font': [] }],
        [{ 'align': [] }],

        ['clean'],                                         // remove formatting button
        ['link']
        //['link', 'image', 'video']                         // link and image, video
      ]
    }
  }

  ngOnInit() {

    $(() => {
      // Basic instantiation:
      (<any>$('#colorpicker')).colorpicker(
        {
          inline: true,
          container: true
        }
      );

      // Example using an event, to change the color of the .jumbotron background:
      // $('#demo').on('colorpickerChange', function (event) {
      //   $('.jumbotron').css('background-color', (<any>event).color.toString());

      // });
      $('#colorpicker').on('colorpickerChange', (event) => {
        this.editItem.backgroundColor = (<any>event).color.toString();
      });
    });

    // this.eventService.getAllEventsByType(this.eventType).subscribe(res => {
    //   this.events = res;
    //   console.log(res);
    // });

    // this.eventService.getAllEventsByType(this.meerdaageType).subscribe(res => {
    //   this.meerdaagses = res;
    //   console.log(res);
    // });

    this.eventService.getAllVisibleEvents().subscribe(res => {
      this.events = res;  
    });
    
    this.newOtherItem();
    
    if (this.editItem.id > -1){
      this.frontpageService.getFrontPageItem(this.editItem.id).subscribe(res =>{
        this.editItem = res;
        // console.log(this.editItem)
        this.positionChanged()
      });
    }
    
  }

  SaveBlock() {
    // console.log("editItem posistion: "+this.editItem.position)
    // console.log("position: "+ this.position)
    // console.log(this.editItem)
    var frontpage_item = {
      title: this.editItem.title,
      content: this.editItem.content,
      backgroundColor: this.editItem.backgroundColor,
      url: this.editItem.url,
      buttonText: this.editItem.buttonText,
      eventId: this.editItem.eventId,
      image: this.editItem.image,
      position: this.editItem.position,
      id: this.editItem.id
      
    }
    if (this.editItem.id <= 0){
        this.frontpageService.create(frontpage_item).subscribe( x => {
          // console.log(x);
          this.alertService.success("Nieuw item opgeslagen", true);
        });
    }
    else{
      this.frontpageService.update(frontpage_item).subscribe( x => {
        this.alertService.success("Wijzigingen opgeslagen", true);
        // console.log(x);
      })
    }
    
    this.router.navigate(['/home']);

  }

  newOtherItem() {
    // console.log("in new other:"+this.position);
    // this.editItem = {
    this.editItem.title= "";
    this.editItem.content= "";
    this.editItem.backgroundColor= "";
    this.editItem.url= "";
    this.editItem.buttonText= "";
    this.editItem.eventId= -1;
    this.editItem.image= "";    
    this.editItem.position= "left";
    // }
    // console.log(this.editItem)
  }

  uploadFoto() {
    var nativeElement: HTMLInputElement = this.fileInput.nativeElement;
    if (nativeElement != null) {
      var files = nativeElement.files;
      if (files != null) {
        var file = files[0];
        // console.log("Upload file: ")
        // console.log(file.name);
        this.uploadService.uploadFileToFrontPage(file).subscribe(x => {
          this.editItem.image = x.filename;
        })
      }
    }
  }

  removeImage(image:any){
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.uploadService.deleteFileFromFrontPage(this.editItem.image).subscribe( x => {
            // console.log(x);
            this.editItem.image = ""
          })
        }
      });
  }

  positionChanged(){
    switch (this.editItem.position) {
      case "left":
        this.columnWidthPreview = "col-lg-4"  
        this.videoWidth = "340";
        break;
      case "right":
        this.columnWidthPreview = "col-lg-3"  
        this.videoWidth = "248";
        break;
      default:
        this.columnWidthPreview = "col-lg-4"  
        this.videoWidth = "340";
        break;
    }
  }



  getFilenameType(filename: string){
    var ext = "";
    var res = ""
    if (filename.length > 0){
      ext = filename.substr(filename.lastIndexOf('.')+1,4).toLowerCase()
      switch (ext) {
        case "mp4":
          res = "video";        
          break;
        case "":
          res =  "none";
          break;
        
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          res =  "image";
          break;
        default:
          res =  "none"
          break;
      }
    }
    return res;

  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/home-card-edit/home-card-edit.component.ts